import React from "react"

import { graphql } from "gatsby"
import PropTypes from "prop-types"

import Grid from "../components/atoms/grid"
import Heading from "../components/atoms/heading"
import Wrapper from "../components/atoms/wrapper"
import Seo from "../components/head"
import Layout from "../components/layout"
import BackTo from "../components/molecules/back-to"
import Podcast from "../components/molecules/podcast"
import SidebarItem from "../components/molecules/sidebar-item"

const podcastTemplate = ({ data }) => (
  <Layout>
    <Wrapper container>
      <Podcast podcast={data.sanityPodcast} />
      <Heading level="3">
        {
          data.allSanityDictionary.nodes.find(
            (dictionaryItem) => dictionaryItem.key.current === "listening"
          )?.value
        }
      </Heading>
      <Grid col={4}>
        {data.related.nodes.map((podcast) => (
          <div>
            <SidebarItem item={podcast} />
          </div>
        ))}
      </Grid>
      <BackTo
        url="/podcasts"
        name={
          data.allSanityDictionary.nodes.find(
            (dictionaryItem) => dictionaryItem.key.current === "all_podcasts"
          )?.value
        }
      />
    </Wrapper>
  </Layout>
)

podcastTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}

export default podcastTemplate

const HeadComponent = ({ data, location }) => (
  <Seo
    title={`${
      data.allSanityDictionary.nodes.find(
        (dictionaryItem) => dictionaryItem.key.current === "podcast_title"
      )?.value
    } ${
      data.sanityPodcast.episode_number > 0
        ? `Ep #${data.sanityPodcast.episode_number}: `
        : ""
    }${data.sanityPodcast.title}`}
    path={location.pathname}
    image={
      data.sanityPodcast.image?.asset
        ? `${data.site.siteMetadata.siteUrl}${data.sanityPodcast.image.asset.publicUrl}`
        : null
    }
  />
)

HeadComponent.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}

export const Head = HeadComponent

export const pageQuery = graphql`
  query podcastQuery($id: String!, $related: [String]!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    allSanityDictionary {
      nodes {
        key {
          current
        }
        value
      }
    }
    sanityPodcast(id: { eq: $id }) {
      urls {
        url
        platform
      }
      title
      _rawSummary
      slug {
        current
      }
      image {
        ...ImageWithPreview
        asset {
          publicUrl
        }
      }
      date
      episode_number
    }
    related: allSanityPodcast(
      filter: { id: { in: $related } }
      sort: { episode_number: DESC }
    ) {
      nodes {
        type: _type
        title
        episode_number
        slug {
          current
        }
        image {
          ...ImageWithPreview
        }
      }
    }
  }
`
